// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__AJsX2","soundWrapper":"Layout_soundWrapper__51PO9","sound":"Layout_sound__HzkBW","braid":"Layout_braid__e5pby","darkMode":"Layout_darkMode__Fm3Q+"};